import { z } from "zod";
export const csaSeasonSchema = z.enum(["Spring", "Summer", "Fall", "Multi-Season"]);
export const legalCSASeasons = csaSeasonSchema.options;
//# sourceMappingURL=csas.js.map